module.exports = __webpack_public_path__ + "img/agenda.c60ad43d.svg";